import TextareaAutosize from 'react-textarea-autosize'
import styled from '../../../config/theme'

const InputContainer = styled.form`
  background: white;
  margin: 0 10px 10px;
  border: 1px solid ${props => props.theme.color.lightGray};
  border-radius: 5px;
  display: flex;
  position: relative;
  margin-top: 20px;
  /* min-height: 40px; */
`

const TextArea = styled(TextareaAutosize)`
  flex: 1;
  border: none;

  color: ${props => props.theme.color.darkGray};

  font-size: ${props => props.theme.fontSize.regular};
  padding: 8px;

  margin-right: 5px;
  min-height: 36px;
  height: 36px;
  margin-top: 1px;

  &::placeholder {
    color: ${props => props.theme.color.placeholder};
    opacity: 1;
    font-style: italic;
  }
`

const Attachment = styled.div`
  flex: 1;
  overflow: hidden;

  > img {
    margin: 0 6px;
  }

  span {
    margin-left: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 80%;
    display: inline-block;
    overflow: hidden;
    vertical-align: middle;
  }
`

const ModalContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  flex: 1;
`

const DocumentContainer = styled.div`

`

const ImageContainer = styled.div`
  height: 200px;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    border: 2px solid ${props => props.theme.color.lightGray};
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 5px;
  }
`

const Actions = styled.div`
  > * {
    margin: 0 10px;
  }
`

const Geolocation = styled.iframe`

`

const Status = styled.div<{ online: boolean }>`
  position: absolute;
  top: -20px;
  left: 40%;

  &:before {
    content: '';
    background: ${props => props.online ? 'limeGreen' : 'white'};
    height: 10px;
    width: 10px;
    position: absolute;
    top: 4px;
    left: -18px;
    border-radius: 10px;
    border: 1px solid limegreen;
  }
`

export {
  InputContainer,
  TextArea,
  Attachment,
  ImageContainer,
  DocumentContainer,
  ModalContent,
  Geolocation,
  Actions,
  Status,
}

